import { PAGE } from '@/constants/common';
import { CpfUsagePropertyType, NumberOfExistingProperties } from '@/constants/others/cpf-usage';
import { FormTypes } from '.';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export const initialState = {
  formField: {
    propertyType: CpfUsagePropertyType.HDB,
    propertyPrice: 500000,
    remainingLease: 60,
    youngestAge: 25,
    numberOfExistingProperties: NumberOfExistingProperties.NoProperty,
  } as FormTypes,
  loading: true,
  from: '' as PAGE | '',
};

export const cpfUsageSlice = createSlice({
  name: 'othersCpfUsage',
  initialState,
  reducers: {
    updateDataForm: (
      state,
      action: PayloadAction<
        FormTypes & {
          from: PAGE | '';
        }
      >,
    ) => {
      const { from, ...rest } = action.payload;

      state.formField = rest;
      state.from = action.payload.from;
    },
    updateFrom: (state, action: PayloadAction<PAGE>) => {
      state.from = action.payload;
    },
    reset: () => {
      return initialState;
    },
  },
});

export const { updateDataForm, updateFrom, reset } = cpfUsageSlice.actions;

export default cpfUsageSlice.reducer;
